/*
  "Add a little extra" in de tas: met de muis slepen om naar de volgende
  kaart te gaan, zoals vegen op een telefoon. Alleen voor een muis (pointer
  'mouse'); aanraking scrolt de rij al zelf.

  Een eigen bestand en niet in brand-tas.js: daar werkte op 14-10-2026 een
  tweede sessie in (Order Protection). Tijdens het slepen staat scroll-snap
  uit, anders springt de rij bij elke pixel terug; bij loslaten schuift hij
  naar de dichtstbijzijnde kaart (scroll-snap van de rij). Een klik na echt slepen (meer dan 6 px)
  wordt tegengehouden, zodat loslaten op een kaart die niet opent.
*/
(function () {
  var stijl = document.createElement('style');
  stijl.textContent =
    '@media (hover: hover) and (pointer: fine) {' +
    '.tas-extra__rij { cursor: grab; user-select: none; }' +
    '.tas-extra__rij.is-slepen { cursor: grabbing; scroll-snap-type: none; }' +
    '.tas-extra__rij.is-slepen * { pointer-events: none; }' +
    '.tas-extra__rij img { -webkit-user-drag: none; user-drag: none; }' +
    '}';
  document.head.appendChild(stijl);

  var rij = null, startX = 0, startScroll = 0, gesleept = false, eind = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var r = e.target.closest('.tas-extra__rij');
    /* Op een knop of maatvak niet beginnen: die moeten gewoon klikken. */
    if (!r || e.target.closest('button, select, input')) return;
    rij = r; startX = e.clientX; startScroll = r.scrollLeft; gesleept = false;
  });

  document.addEventListener('pointermove', function (e) {
    if (!rij) return;
    var dx = e.clientX - startX;
    if (!gesleept && Math.abs(dx) > 6) { gesleept = true; rij.classList.add('is-slepen'); }
    if (gesleept) { rij.scrollLeft = startScroll - dx; e.preventDefault(); }
  });

  function los() {
    if (!rij) return;
    var r = rij; rij = null;
    if (!gesleept) return;
    gesleept = false; eind = Date.now();
    r.classList.remove('is-slepen');
    /* Uitlijnen op de dichtstbijzijnde kaart doet scroll-snap zelf zodra
       de klasse eraf is; een eigen scrollBy erachteraan schoof hem terug. */
  }
  document.addEventListener('pointerup', los);
  document.addEventListener('pointercancel', los);

  /* Na slepen geen klik op een link in de kaart. */
  document.addEventListener('click', function (e) {
    if (Date.now() - eind < 300 && e.target.closest('.tas-extra__rij')) {
      e.preventDefault(); e.stopPropagation();
    }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.tas-extra__rij')) e.preventDefault();
  });
})();
